import { useInitLocationSearchMachine } from '../useInitLocationSearchMachine';
import { useLocationSearchFlags } from '../useLocationSearchFlags';
import { useLocationSearchHelpers } from '../useLocationSearchHelpers';

import type { LocationSearchMachineContext } from '../../machine';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Owns the location search machine instance and exposes the actor ref plus its
 * derived `flags` and `helpers`.
 */
export const useLocationSearchMachine = (params: Params) => {
  const { isInsideModal, navigateToLocation, navigateToDeliveryLocation } = params;

  const [state, , service] = useInitLocationSearchMachine({
    isInsideModal,
    navigateToLocation,
    navigateToDeliveryLocation,
  });

  const flags = useLocationSearchFlags({ locationSearchActorRef: service });
  const helpers = useLocationSearchHelpers({ locationSearchActorRef: service });

  // ─────────────────────────────────────────────────────────────────────

  return { state, service, flags, helpers };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  isInsideModal?: boolean;

  /*
    Optional actions that initiates the navigation process for the selected location.
    When those properties are not provided, the standard navigation is used.

    Helpful when a custom navigation method is utilized or when other actions
    need to be performed before navigation.
   */

  navigateToLocation?: (context: LocationSearchMachineContext) => void;
  navigateToDeliveryLocation?: (context: LocationSearchMachineContext) => void;
};
